/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import marketMetrics
from "../../data/metrics/marketMetrics.json";

import derivativesMetrics
from "../../data/metrics/derivativesMetrics.json";

import stockMetrics
from "../../data/metrics/stockMetrics.json";

import mutualFundMetrics
from "../../data/metrics/mutualFundMetrics.json";

// import portfolioMetrics
// from "../../data/metrics/portfolioMetrics.json";
//
// import strategyMetrics
// from "../../data/metrics/strategyMetrics.json";
//
// import screenerMetrics
// from "../../data/metrics/screenerMetrics.json";
//
// import riskMetrics
// from "../../data/metrics/riskMetrics.json";

export const metricRegistry = {

    market: marketMetrics,

    derivatives: derivativesMetrics,

    stocks: stockMetrics,

    mutualfunds: mutualFundMetrics,

    // portfolio: portfolioMetrics,
    //
    // strategies: strategyMetrics,
    //
    // screener: screenerMetrics,
    //
    // risk: riskMetrics

};